import { createApiMetricPair } from "@repo/monitoring";

const amcChartMetrics = createApiMetricPair({
  apiName: "amc_mutual_funds_chart",
  displayName: "AMC mutual funds chart API",
  urlPatterns: ["/api/v2/mutual-funds-chart-list"],
  methods: ["POST"],
});

const amcPdpApiMetricGroups = [amcChartMetrics];

export const amcPdpApiMetrics = amcPdpApiMetricGroups.flatMap((group) => group.metrics);
export const amcPdpApiMonitors = amcPdpApiMetricGroups.map((group) => group.apiMonitor);
export const amcPdpApiNames = amcPdpApiMonitors.map((monitor) => monitor.apiName);
